@if (!isGoodsAndServicesOnly) {
    @if (isNewReferral) {
        <ppl-accordion [title]="'Forms'" [isOpen]="true">
            <ppl-provider-forms [readonly]="mode" [isNewReferral]="isNewReferral" (isMandatoryFormsCompleted)="isMandatoryFormsCompleted($event)"></ppl-provider-forms>
        </ppl-accordion>
    } @else {
        <ppl-accordion [title]="'Forms'" [isOpen]="true" *authorize="[pageId, tabId, 'Forms', 'section']">
            <ppl-provider-forms [readonly]="mode" [isNewReferral]="isNewReferral" (isMandatoryFormsCompleted)="isMandatoryFormsCompleted($event)"></ppl-provider-forms>
        </ppl-accordion>
    }

    <!-- Mail Summary section hidden for go-live: hidden for all roles -->
    <!-- @if(!isNewReferral && !isMobile){
        <ppl-accordion [title]="'Mail Summary'" [isOpen]="true">
            <ppl-list-table [disableSort]="true" [disableSearch]="true" [data]="mailFormsData"
                [disableSelection]="true" [cols]="cols" [gridTitle]="false" [pagination]="false"
                [loadPage]="true">
            </ppl-list-table>
        </ppl-accordion>
    } -->
} @else {
    <ppl-accordion [title]="'Forms'" [isOpen]="true">
        <nz-alert nzType="info" nzMessage="No forms available for you." nzShowIcon></nz-alert>
    </ppl-accordion>
}